/* Fix ricerca mobile (Claude) - sposta il bottone di chiusura (X) dentro
   la barra di ricerca (.search .field), invece di lasciarlo nell'icona
   originale in alto nell'header (.header__icon--search), che e' un
   contenitore diverso e scollegato visivamente dall'overlay di ricerca su
   mobile. Il nodo viene spostato (non clonato), quindi il listener di
   chiusura gia' presente in header.js resta attivo. */
(function () {
	function moveCloseButtons() {
		document.querySelectorAll('.header__search').forEach(function (wrapper) {
			var closeBtn = wrapper.querySelector('.header__search-mobile-close');
			var field = wrapper.querySelector('.header__search-inner .search .field');
			if (closeBtn && field && closeBtn.parentElement !== field) {
				field.appendChild(closeBtn);
			}
		});
	}

	if (document.readyState !== 'loading') {
		moveCloseButtons();
	} else {
		document.addEventListener('DOMContentLoaded', moveCloseButtons);
	}
	document.addEventListener('shopify:section:load', moveCloseButtons);
})();
